import { render, staticRenderFns } from "./slideshowDefault.vue?vue&type=template&id=74e7f3ea"
import script from "./slideshowDefault.vue?vue&type=script&lang=js"
export * from "./slideshowDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/frontend/components/kirbyimage.vue').default})
